export const formatTimeAgo = (date: Date) => {
  const now = new Date();
  const secondsPast = (now.getTime() - date.getTime()) / 1000;

  if (secondsPast < 60) {
    const s = Math.round(secondsPast);
    const seconds = s === 1 ? "second" : "seconds";
    return `${s} ${seconds} ago`;
  }
  if (secondsPast < 3600) {
    const m = Math.round(secondsPast / 60);
    const minutes = m === 1 ? "minute" : "minutes";
    return `${m} ${minutes} ago`;
  }
  if (secondsPast < 86400) {
    const h = Math.round(secondsPast / 3600);
    const hours = h === 1 ? "hour" : "hours";
    return `${h} ${hours} ago`;
  }
  if (secondsPast < 604800) {
    const d = Math.round(secondsPast / 86400);
    const days = d === 1 ? "day" : "days";
    return `${d} ${days} ago`;
  }
  if (secondsPast < 2629743) {
    const w = Math.round(secondsPast / 604800);
    const weeks = w === 1 ? "week" : "weeks";
    return `${w} ${weeks} ago`;
  }
  if (secondsPast <= 31556926) {
    const m = Math.round(secondsPast / 2629743);
    const months = m === 1 ? "month" : "months";
    return `${m} ${months} ago`;
  }
  if (secondsPast > 31556926) {
    const y = Math.round(secondsPast / 31556926);
    const years = y === 1 ? "year" : "years";
    return `${y} ${years} ago`;
  }
};
